import { InjectionToken } from '@angular/core';

/**
 * JWT options constant
 */
export const JWT_OPTIONS = new InjectionToken('JWT_OPTIONS');
